import { xor } from 'lodash';
import React, { useCallback } from 'react';
import { ButtonToolbar, DropdownButton, MenuItem } from 'react-bootstrap';
import { connect } from 'react-redux';
import { navigateToProjectReports } from '../../../links/index.jsx';
import { selectOrgMilestones } from '../../../../modules/orgMilestones.js';
import { selectReadyProjects } from '../../../../modules/projects.js';
import { getOrgTermsContent } from '../../../../content/utils.js';
import { selectPortfolios } from '../../../../modules/portfolio.js';

MilestonesFilter.defaultProps = {
  orgMilestones: [],
  selectedMilestoneIds: [],
};

const mapStateToProps = (state) => ({
  orgMilestones: selectOrgMilestones(state),
  projects: selectReadyProjects(state),
  portfolios: selectPortfolios(state),
});

function MilestonesFilter({
  projects,
  portfolios,
  orgMilestones,
  selectedMilestoneIds,
  type,
}) {
  const filteredMilestones = orgMilestones.filter((m) => m[`${type}_id`]);
  const selectedCount = selectedMilestoneIds.length;
  const uniqueParentIds = [
    ...new Set(filteredMilestones.map((obj) => obj[`${type}_id`])),
  ];
  const parentName = (id) => {
    const entity =
      id &&
      (type === 'project' ? projects : portfolios).find((p) => p.id === id);
    return entity ? entity.name : '';
  };
  const parentMilestones = (id) =>
    filteredMilestones.filter((milestone) => milestone[`${type}_id`] === id);

  const handleSelect = useCallback(
    (milestonesId) =>
      navigateToProjectReports({
        [`${type}MilestoneIds`]: milestonesId
          ? xor(selectedMilestoneIds, [milestonesId])
          : [],
      }),
    [selectedMilestoneIds]
  );

  const renderMenuItem = useCallback(
    (milestone) => (
      <React.Fragment key={milestone.id}>
        <MenuItem
          active={selectedMilestoneIds.includes(milestone.id)}
          eventKey={milestone.id}
          onSelect={handleSelect}
        >
          {milestone.name}
        </MenuItem>
      </React.Fragment>
    ),
    [selectedMilestoneIds]
  );

  return (
    <div className="flex-col report-filter">
      <div className="text-muted filter-label">
        {getOrgTermsContent(type)} Milestones
      </div>
      <ButtonToolbar>
        <DropdownButton
          bsStyle="info"
          title={selectedCount ? `${selectedCount} Selected` : 'All'}
          id="milestones-filter"
          className="btn-block"
          onSelect={handleSelect}
          pullRight
        >
          <MenuItem active={selectedCount === 0}>All</MenuItem>
          <MenuItem divider />
          {uniqueParentIds.map((id) => {
            return (
              <React.Fragment key={id}>
                <MenuItem header>{parentName(id)}</MenuItem>
                {parentMilestones(id).map(renderMenuItem)}
                <MenuItem divider />
              </React.Fragment>
            );
          })}
        </DropdownButton>
      </ButtonToolbar>
    </div>
  );
}

export default connect(mapStateToProps)(MilestonesFilter);
